























































// @ is an alias to /src
//import { defineComponent, reactive, computed, watch, onMounted, SetupContext } from '@vue/composition-api';
import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import Auth from '@aws-amplify/auth';

import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: 'Login',
  components: {
    Header,
    Footer
  },
  head: {
    link: [
      { rel: "stylesheet", type: "text/css", href: "/css/style.css" }
    ]
  },

  setup(_, context: SetupContext) {
    const state = reactive({
      email: '',
      password: ''
    });

    async function login() {
      Auth.signIn(state.email, state.password).then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          const { requiredAttributes } = user.challengeParam;
          // sorry for that...
          Auth.completeNewPassword(user, state.password, requiredAttributes).then(user => {
            console.log(user);
            context.root.$router.push('/project');
          }).catch(err => {
            console.log('Failed to force login...');
            console.log(err);
          })
        } else {
          console.log(user);
          context.root.$router.push('/project');
        }
      }).catch(err => {
        console.log('Failed to login...');
        console.log(err);
      });
    }

    async function logout() {
      Auth.signOut()
        .then(data => console.log(data))
        .catch(err => console.log(err));
    }

    return {
      state,
      login,
      logout
    };
  }
});

/*
  setup() {
    const state = reactive({
      passwordVisibility: 'password'
    });

    function switchVisibility() {
      if (state.passwordVisibility === 'password') {
        state.passwordVisibility = 'text';
      } else {
        state.passwordVisibility = 'password';
      }
    }

    function login() {
      alert("Trying to login!!!");
    }

    return {
      state,
      switchVisibility,
      login,
    };
  }
*/
